export const generateHash = () =>
  Math.random()
    .toString(36)
    .substring(2, 10);

export const serialize = form => {
  let field;

  let l;

  const s = [];

  if (typeof form === 'object' && form.nodeName === 'FORM') {
    const len = form.elements.length;
    for (let i = 0; i < len; i++) {
      field = form.elements[i];
      if (
        field.name &&
        !field.disabled &&
        field.type !== 'file' &&
        field.type !== 'reset' &&
        field.type !== 'submit' &&
        field.type !== 'button'
      ) {
        if (field.type === 'select-multiple') {
          l = form.elements[i].options.length;
          for (let j = 0; j < l; j++) {
            if (field.options[j].selected) {
              s[s.length] = `${encodeURIComponent(
                field.name,
              )}=${encodeURIComponent(field.options[j].value)}`;
            }
          }
        } else if (
          (field.type !== 'checkbox' && field.type !== 'radio') ||
          field.checked
        ) {
          s[s.length] = `${encodeURIComponent(
            field.name,
          )}=${encodeURIComponent(field.value)}`;
        }
      }
    }
  }
  return s.join('&').replace(/%20/g, '+');
};
